import React, { useState } from 'react';
import { ShieldCheck, X } from 'lucide-react';

const PRINCIPLES = [
  { letter: 'A', name: 'Attributable',      desc: 'Who performed the action and when'              },
  { letter: 'L', name: 'Legible',           desc: 'Data is readable and permanent'                  },
  { letter: 'C', name: 'Contemporaneous',   desc: 'Recorded at the time of the activity'            },
  { letter: 'O', name: 'Original',          desc: 'First recorded data preserved with audit trail'  },
  { letter: 'A', name: 'Accurate',          desc: 'Free from errors; reflects what was done'        },
  { letter: '+', name: 'Complete',          desc: 'All data including invalidated entries retained'  },
];

export default function ALCOABadge() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onClick={() => setShowTooltip(!showTooltip)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          padding: '3px 9px', borderRadius: 6, cursor: 'pointer',
          background: 'linear-gradient(135deg, #F0FDF4, #DCFCE7)',
          border: '1px solid rgba(22,163,74,0.25)',
          fontSize: 10.5, fontWeight: 700, color: '#16A34A',
          letterSpacing: '0.6px',
        }}
      >
        <ShieldCheck size={11} strokeWidth={2.5} />
        ALCOA+
      </button>

      {showTooltip && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 6px)', right: 0,
          background: '#fff', borderRadius: 10, padding: '12px 14px',
          boxShadow: '0 8px 24px rgba(15,23,42,0.12), 0 2px 6px rgba(15,23,42,0.06)',
          border: '1px solid rgba(0,0,0,0.1)', width: 240, zIndex: 9999,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#1a1a2e' }}>Data Integrity — ALCOA+</p>
            <X size={12} color="#94A3B8" style={{ cursor: 'pointer' }} onClick={() => setShowTooltip(false)} />
          </div>
          {PRINCIPLES.map((p) => (
            <div key={p.name} style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'flex-start' }}>
              <span style={{
                fontSize: 10, fontWeight: 900, color: '#16A34A',
                background: '#F0FDF4', borderRadius: 4, padding: '1px 5px',
                flexShrink: 0, minWidth: 18, textAlign: 'center',
              }}>{p.letter}</span>
              <div>
                <p style={{ fontSize: 10.5, fontWeight: 700, color: '#1a1a2e', lineHeight: 1.2 }}>{p.name}</p>
                <p style={{ fontSize: 10, color: '#5a5a6e', lineHeight: 1.3 }}>{p.desc}</p>
              </div>
            </div>
          ))}
          <p style={{ fontSize: 9.5, color: '#94A3B8', marginTop: 8, borderTop: '1px solid rgba(0,0,0,0.04)', paddingTop: 6 }}>
            Per FDA 21 CFR Part 11 &amp; EU Annex 11
          </p>
        </div>
      )}
    </div>
  );
}
